import {AlertService} from '../../shared/services/alert.service';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { Assessment } from "../../shared/models/assessment";
import { QuestionSet} from "../../shared/models/question-set";
import { QuestionAnswerPopulator } from "../../shared/services/question-answer-populator.service";

@Component({
  selector: 'dac-assessment',
  templateUrl: './assessment.component.html',
  styleUrls: ['./assessment.component.css']
})
export class AssessmentComponent implements OnInit, OnChanges {
  @Output() onSubmit = new EventEmitter<Assessment>();
  @Input("assessment") assessment:Assessment;
  @Input("disabled") disabled:Boolean;
	private _currentQuestionSet:QuestionSet;
	private _currentAssessmentId:string;  
	private _currentIndex = 0;
	private _maxQuestionSetsIndex = 0;
	private _displayQuestionSets:QuestionSet[];
	private _showInstructions:boolean;

  constructor(protected alertService: AlertService, private questionPopulator:QuestionAnswerPopulator) { 
	  this._currentAssessmentId = null;
	  this._showInstructions = true;
  }

	ngOnInit() {}

	ngOnChanges(changes:SimpleChanges) {
		// we've changed assessments, so recalculate our index here.
		if (this.assessment && this._currentAssessmentId != this.assessment.id) {
			this._currentAssessmentId = this.assessment.id;
			this._displayQuestionSets = this.getQuestionSetsForDisplay(this.assessment);
			let qs = this._displayQuestionSets.length ? this._displayQuestionSets[0] : null;
			if (qs !== null) {
				this.setCurrentQuestionSet(qs);
			}
			this.calculateDisplayIndexesForQuestions(this.assessment);
		}
	}

	protected getQuestionSetsForDisplay(assessment:Assessment) {
		return assessment.getQuestionSetsForDisplay();
	}

	protected getNextQuestionSetToDisplay(assessment:Assessment, currentQuestionSet:QuestionSet) {
		return assessment.getNextQuestionSetToDisplay(currentQuestionSet);
	}

	protected getPreviousQuestionSetToDisplay(assessment:Assessment, currentQuestionSet:QuestionSet) {
		return assessment.getPreviousQuestionSetToDisplay(currentQuestionSet);
	}


  private calculateDisplayIndexesForQuestions(assessment:Assessment) : void {
		let display_index:number = 1;
		this._displayQuestionSets.forEach(qs => { qs.questions.forEach(q => {q.display_index = display_index++ })});
	}

  public get maxQuestionSetsIndex() : number {
		if (this.assessment) {
			let sets = this._displayQuestionSets;
			return sets.length - 1 > 0 ? sets.length - 1 : 0;
		}
		return 0;
  }
	
	public get currentIndex() : number {
		let sets = this._displayQuestionSets || [];
		return sets.indexOf(this.currentQuestionSet);
	}

  public get currentQuestionSet() : QuestionSet {
    return this._currentQuestionSet;
  }
	
	public setCurrentQuestionSet(qs:QuestionSet) {
		if (qs !== this._currentQuestionSet
			&& qs.instructions) {
			 // Since the new question set instructions changed, let's make sure to show
			 // our instructions again...
			this.showInstructions();
		}
			this._currentQuestionSet = qs;
			// we have some scrolling issues so let's fix that.
			window.scrollTo(0, 0);
	}
	
	public nextSet() {
		if (this.hasUnansweredQuestions()) {
			// display an alert
			this.alertService.error("Please answer all of the questions before proceeding");
			return;
		}
		let qs = this.getNextQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
		this._displayQuestionSets = this.getQuestionSetsForDisplay(this.assessment); // update the question set
		this.setCurrentQuestionSet(qs);
		// we recalculate the question numbering since a current question set can trigger another question set to display
		this.calculateDisplayIndexesForQuestions(this.assessment);
	}

	protected hasUnansweredQuestions() {
		let unAnsweredQuestions = this.currentQuestionSet.questions.filter(q => !q.isFilledOut);
		return unAnsweredQuestions.length > 0;
	}

	public get hasNextSet() {
		if (!this.assessment) {
			return false;
		}
		
		let qs = this.getNextQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
		return qs != null;
	}

	public get hasPreviousSet() {
		if (!this.assessment) {
			return false;
		}
		let qs = this.getPreviousQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
		return qs != null;
	}
	
	public previousSet() {
		let qs = this.getPreviousQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
		this._displayQuestionSets = this.getQuestionSetsForDisplay(this.assessment); // update the question set
		this.setCurrentQuestionSet(qs);
		this.calculateDisplayIndexesForQuestions(this.assessment);
		// let index = Math.max(this.currentIndex - 1, 0);
		// this.setCurrentSetForIndex(index);
	}

	public hasInstructions() {
		if (this.assessment && this.assessment.instructions) {
			return true;
		}

		if (this.currentQuestionSet && this.currentQuestionSet.instructions) {
			return true;
		}
		return false;
	}

	public shouldShowInstructions() {
		return this._showInstructions;
	}

	public showInstructions() {
		this._showInstructions = true;
	}
	public hideInstructions() {
		this._showInstructions = false;
	}
  
	selectSample() {
		let qs = this.assessment.getFirstQuestionSetToDisplay();
		if (qs == null) {
			return;
		}
		do {
			qs.questions.forEach(q => this.questionPopulator.populateQuestion(q, qs));
			qs = this.getNextQuestionSetToDisplay(this.assessment, this.currentQuestionSet);
		} while (qs !== null);
	}

  submit() {
		if (this.hasUnansweredQuestions()) {
			this.alertService.error("Please answer all of the questions before submitting");
			return;
		}

    this.onSubmit.emit(this.assessment);
  }
}



// WEBPACK FOOTER //
// ./src/app/assessments/assessment/assessment.component.ts